import { Routes } from '@angular/router';
import { ExtractsDashboardComponent } from './components/extracts-dashboard.component';
import { CalOmsExtractWorkspaceComponent } from './components/caloms-extract-workspace.component';

export const extractsRoutes: Routes = [
  {
    path: 'extracts',
    component: ExtractsDashboardComponent,
    data: {
      title: 'Extracts',
      isNav:  true,
      icon: 'assignment_returned',
      permissions: ['ExtractsModule.Extracts:View']
    },
    children: [
    ]
  },
  {
    path: 'extract-workspace/:key',
    component: CalOmsExtractWorkspaceComponent,
    data: {
      title: 'Extracts',
      isNav: false,
      icon: 'assignment_returned',
      permissions: ['ExtractsModule.Extracts:View']
    }
  }

];



// WEBPACK FOOTER //
// ./src/app/extracts/routes.config.ts